import * as React from 'react';
import TraceToggle from 'owa-analytics/lib/components/traceToggle';
import { getDiagnosticsLogState } from '../store/store';
import { observer } from 'mobx-react';
import DiagnosticToggle from './DiagnosticToggle';
import { isFeatureEnabled, setFeatureFlag } from 'owa-feature-flags';

@observer
export default class DiagnosticsInfo extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <pre>{getDiagnosticsLogState().sessionDetails}</pre>
                <TraceToggle />
                <DiagnosticToggle
                    toggleValue={!isFeatureEnabled('fwk-prefetch-code-off')}
                    toggleTitle="code prefetch"
                    changeAction={value => setFeatureFlag('fwk-prefetch-code-off', !value)}
                />
                <DiagnosticToggle
                    toggleValue={!isFeatureEnabled('fwk-prefetch-data-off')}
                    toggleTitle="data prefetch"
                    changeAction={value => setFeatureFlag('fwk-prefetch-data-off', !value)}
                />
                <DiagnosticToggle
                    toggleValue={!isFeatureEnabled('fwk-partner-code-off')}
                    toggleTitle="partner code"
                    changeAction={value => setFeatureFlag('fwk-partner-code-off', !value)}
                />
            </div>
        );
    }
}

export function renderDiagnosticsInfo() {
    return <DiagnosticsInfo />;
}
